import { CacheProvider, EmotionCache } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  StyledEngineProvider,
  ThemeOptions,
  ThemeProvider,
} from '@mui/material/styles';
import Script from 'next/script';
import { FC, PropsWithChildren, ReactNode, useMemo } from 'react';

import { themeOptions } from '../theme';

export const CustomStyledProvider = ({
  children,
  cache,
}: {
  children?: ReactNode;
  cache: EmotionCache;
}): JSX.Element => {
  return (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </StyledEngineProvider>
  );
};

const MaterialProvider: FC<
  PropsWithChildren<{
    theme?(themeOptions: ThemeOptions): Partial<ThemeOptions>;
    hasTinyMce?: boolean;
    hasLeaflet?: boolean;
    cache?: EmotionCache;
  }>
> = ({ theme, children, hasTinyMce = true, hasLeaflet = true, cache }) => {
  const cdnURL = process.env['NEXT_PUBLIC_CDN'];
  const innerTheme = theme?.(themeOptions);

  const usedTheme = useMemo(() => createTheme(innerTheme ?? themeOptions), [innerTheme]);
  return (
    <ThemeProvider theme={usedTheme}>
      <link
        rel="stylesheet"
        href={`${cdnURL}/cdn/fonts/iranYekanX/Farsi_numerals/Webfonts/fontiran.css`}
      />
      <link rel="stylesheet" href={`${cdnURL}/cdn/fonts/unicons/css/line.css`} />

      {hasLeaflet && (
        <>
          <link rel="stylesheet" href={`${cdnURL}/cdn/leaflet.min.css`} />
          <link rel="stylesheet" href={`${cdnURL}/cdn/leaflet.draw.min.css`} />
        </>
      )}
      {hasTinyMce && (
        <Script src={`${cdnURL}/cdn/tinymce/tinymce.min.js`} strategy="afterInteractive" />
      )}

      {/* <link rel="stylesheet" href={`${cdnURL}/cdn/fonts/Peyda/fontpayda.css`} /> */}
      {/* <link rel="stylesheet" href={`${cdnURL}/cdn/fonts/IRanSans/fontiran.css`} /> */}
      {/* <link rel="stylesheet" href="https://api.mapbox.com/mapbox-gl-js/v1.13.0/mapbox-gl.css" />
      <link
        rel="stylesheet"
        href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.0/mapbox-gl-draw.css"
        type="text/css"
      /> */}

      {cache ? (
        <CustomStyledProvider cache={cache}>
          <CssBaseline />
          {children}
        </CustomStyledProvider>
      ) : (
        <>
          <CssBaseline />
          {children}
        </>
      )}
    </ThemeProvider>
  );
};

export default MaterialProvider;
